import React from "react";

export default function ContentCard({ post }) {
  // logic to determine what to display depending on the content type

  switch (post.post_type) {
    case "events": {
      const { blurb, date, apply_by, time, location, price, featured_image } =
        post.event_metadata;
      return (
        <article className="post-preview-card grid">
          {featured_image ? (
            <div className="post-preview-card-image col-start-1 col-end-8">
              <img
                src={featured_image.sizes["medium_large"]}
                alt={featured_image.alt}
              />
            </div>
          ) : (
            <div className="post-preview-card-image col-start-1 col-end-8">
              <div className="post-preview-card-image-placeholder logo"></div>
            </div>
          )}

          <div className="post-preview-card-text col-start-8 col-end-20">
            <h4 className="font-size-xl">{post.post_title}</h4>

            <div className="post-preview-card-meta">
              {date && <span className="meta font-size-s">{date}</span>}
              {apply_by && (
                <span className="meta font-size-s">Apply by {apply_by}</span>
              )}
              {time && <span className="meta font-size-s">{time}</span>}
              <div className="event-meta">
                {location && (
                  <span className="meta font-size-s">{location}</span>
                )}
                {price && <span className="meta font-size-s">{price}</span>}
              </div>
            </div>
            <div
              className="post-preview-card-intro font-size-m"
              dangerouslySetInnerHTML={{ __html: blurb }}
            ></div>
          </div>
        </article>
      );
    }
    case "post": {
      const { blurb, date, tags, featured_image } = post.story_metadata;
      return (
        <article className="post-preview-card grid">
          {featured_image ? (
            <div className="post-preview-card-image col-start-1 col-end-8">
              <img
                src={featured_image.sizes["medium_large"]}
                alt={featured_image.alt}
              />
            </div>
          ) : (
            <div className="post-preview-card-image col-start-1 col-end-8">
              <div className="post-preview-card-image-placeholder logo"></div>
            </div>
          )}

          <div className="post-preview-card-text col-start-8 col-end-20">
            <h4 className="font-size-xl">{post.post_title}</h4>

            <div className="post-preview-card-meta">
              {date && <span className="meta font-size-s">{date}</span>}
              {tags && (
                <ul className="meta meta--tags">
                  {tags.map((tag) => (
                    <li key={tag.term_id} className="font-size-s">
                      {tag.name}
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div
              className="post-preview-card-intro font-size-m"
              dangerouslySetInnerHTML={{ __html: blurb }}
            ></div>
          </div>
        </article>
      );
    }
    case "portfolio": {
      const { website_url, logo, intro } = post.portfolio_metadata;
      return (
        <article className="post-preview-card grid">
          {logo ? (
            <div className="post-preview-card-image col-start-1 col-end-6">
              <img style={{'border': '1px solid #ccc' }} src={logo} alt="" />
            </div>
          ) : (
            <div className="post-preview-card-image col-start-1 col-end-8">
              <div className="post-preview-card-image-placeholder logo"></div>
            </div>
          )}
          <div className="post-preview-card-text col-start-6 col-end-20">
            <h4 className="font-size-xl">{post.post_title}</h4>

            <div
              className="post-preview-card-intro font-size-m"
              dangerouslySetInnerHTML={{ __html: intro }}
            ></div>

            <div
              className="font-size-m"
              style={{ marginTop: '1rem' }}
            >
              Visit
              &nbsp;
              <span style={{ textDecoration: 'underline', color: '#134842' }}>{website_url.replace(/https?:\/\//, "")}{" "}</span>
            </div>
          </div>
        </article>
      );
    }
    default:
      return (
        <div className="content-card-post">
          {post.post_title && <h4 className="heading-m">{post.post_title}</h4>}
          {post.summary && <p>{post.summary}</p>}
        </div>
      );
  }
}
